import { createReducer, Action, on } from '@ngrx/store';

import * as LegalRestrictionActions from './legal-restriction.actions';
import { LegalRestrictionState } from '../legal-restriction.model';

const reducer = createReducer<LegalRestrictionState>(
  {
    legalRestrictions: [],
  },
  on(LegalRestrictionActions.setLegalRestriction, (state, { legalRestriction }) => ({
    ...state,
    legalRestrictions: legalRestriction
      ? [...state.legalRestrictions.filter((l) => l.id !== legalRestriction.id), legalRestriction]
      : state.legalRestrictions,
  })),
  on(LegalRestrictionActions.setLegalRestrictions, (state, { legalRestrictions }) => ({
    ...state,
    legalRestrictions: [
      ...state.legalRestrictions.filter(({ id }) => !legalRestrictions.find((l) => id === l.id)),
      ...legalRestrictions,
    ],
  })),
);

export const legalRestrictionReducer = (state: LegalRestrictionState | undefined, action: Action) =>
  reducer(state, action);
